import { render, staticRenderFns } from "./TaughtMeHowtoRestMySoul.vue?vue&type=template&id=4cb9ccfc&scoped=true&lang=pug&"
import script from "./TaughtMeHowtoRestMySoul.vue?vue&type=script&lang=js&"
export * from "./TaughtMeHowtoRestMySoul.vue?vue&type=script&lang=js&"
import style0 from "./TaughtMeHowtoRestMySoul.vue?vue&type=style&index=0&id=4cb9ccfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9ccfc",
  null
  
)

export default component.exports